import { useQueryClient } from '@tanstack/react-query';

import {
  getSubscriptionByChannelID,
  getTariffGrid,
  ITariffGridDto,
  ITariffRequestParamsDto,
} from '@/shared/api/subscriptions';

const BILLING_QUERY_KEY = {
  BASE: 'billing',
  TARIFF: 'tariffGrid',
  SUBSCRIPTION: 'subscription',
} as const;

export const tariffGridQuery = (params: ITariffRequestParamsDto) => ({
  queryKey: [BILLING_QUERY_KEY.BASE, BILLING_QUERY_KEY.TARIFF, params.protocol],
  queryFn: (): Promise<ITariffGridDto[]> =>
    getTariffGrid(params).then((r) => r),
});

export const useInvalidateTariffGrid = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: [BILLING_QUERY_KEY.BASE, BILLING_QUERY_KEY.TARIFF],
    });
};

export const useSubscriptionByChannelIdQuery = (channelId: string) => ({
  queryKey: [BILLING_QUERY_KEY.BASE, BILLING_QUERY_KEY.SUBSCRIPTION, channelId],
  queryFn: () =>
    getSubscriptionByChannelID({ channel_id: channelId }).then((res) => res),
});

export const useInvalidateSubscriptionByChannelId = () => {
  const queryClient = useQueryClient();

  return (channelId: string) =>
    queryClient.invalidateQueries({
      queryKey: [
        BILLING_QUERY_KEY.BASE,
        BILLING_QUERY_KEY.SUBSCRIPTION,
        channelId,
      ],
    });
};
